/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {allUploadType} from '../../constants/uploadTypes';

export const jobs = async (
  type: allUploadType,
  details: string = ''
): Promise<any> => {
  try {
    const token = useUserStore.getState().userToken;

    const companyId = useCompanyStore.getState().companyId;

    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.jobs}/${companyId}/${type}/${details}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};
